<!-- 宠医客学苑 新 -->
<template>
    <div class="content">
		<div class="leftBox">
			<div class="SpecialtyListBox">
				<div class="titles">选择科目</div>
				<div class="specialtyList">
					<div :class="activeSpecialtyId == 0 ?'specialtyItem active':'specialtyItem'" @click="changeActiveSpecialtyId({specialty_id:0})">
						全部
					</div>
					<div :class="activeSpecialtyId == item.specialty_id ?'specialtyItem active':'specialtyItem'" @click="changeActiveSpecialtyId(item)" v-for="(item, index) in SpecialtyDataList" :key="index">
						{{ item.specialty_name }}
					</div>
				</div>
			</div>
			<div class="videoListBox">
				<div class="changeBtnBox">
					<div :class="orderByType == 2 ? 'changeBtnItem active': 'changeBtnItem'" @click="changeorderByType(2)">
						最新
					</div>
					<div :class="orderByType == 1 ? 'changeBtnItem active': 'changeBtnItem'" @click="changeorderByType(1)">
						最热
					</div>
				</div>
				<div class="videoList">
					<div class="videoItem" @click="jumpVideoDetail(item)" v-for="(item, index) in videoDataList" :key="index">
						<el-image
							class="videoImg default" 
							:src="imgSrc+item.class_image"
							fit="cover"></el-image>
						<div class="videoNmae">
							{{ item.class_name }}
						</div>
						<div class="videoLecturer">
							讲师：{{ item.teachers }}
						</div>
						<!-- <div class="videostate">
							更新中{{ item.course_count }}/{{ item.course_count }}
						</div> -->
					</div>
				</div>
			</div>
			<el-pagination
				background
				layout="prev, pager, next"
				:total="total"
				:page-size="12"
				@current-change="changeBtn">
			</el-pagination>
		</div>
		<div class="rightBox">
			<div class="GradeStudyListBox">
				<div class="titles">分级学习</div>
				<div class="gradeStudyList">
					<div class="gradeStudyItem" @click="jumpgradeStudy(item)" v-for="(item, index) in GradeStudyDataList" :key="index">
						<img class="itemIcon" :src="imgSrc + item.grade_image" alt="">
						<div class="itemInfo">
							<div class="name">
								{{ item.grade_name }}
							</div>
							<div class="number">
								{{ item.skill_count }}个模块
							</div>
							<div class="number">
								{{ item.data_count }}节课程
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="GradeStudyListBox GradeStudyListBox2">
				<div class="titles">专科系统课</div>
				<div class="gradeStudyList">
					<div class="gradeStudyItem" @click="jumpjuniorCollege(item)" v-for="(item, index) in SpectialtyDataList" :key="index">
						<img class="itemIcon itemIcon2" :src="imgSrc + item.specialty_image" alt="">
						<div class="itemInfo">
							<div class="name">
								{{ item.specialty_name }}
							</div>
							<div class="number">
								{{ item.skill_count }}个专科
							</div>
							<div class="number">
								{{ item.data_count }}节课程
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>

<script>
export default {
	data() {
		return {
			imgSrc: "https://case.chongyike.com",
            // 分页
            index: 1,
			// 专科列表
			SpecialtyDataList: [],
			// 选中科目ID
			activeSpecialtyId: 0,
			// 总数
            total: 0,
			// 最热1 最新2
			orderByType: 2,
			// 视频列表
			videoDataList: [],
			// 分级学习列表
			GradeStudyDataList: [],
			// 专科系统课
			SpectialtyDataList: []
		}
	},
    mounted(){
        const that = this
        that.getVideoSpecialtyList()
		that.getSpecialtySeries()
		that.getGradeStudy()
		that.getSpectialtyList()
    },
	methods: {
		// 跳转分级学习
		jumpgradeStudy(item){
			this.$router.push({
				path: "/gradeStudy/" + item.grade_id,
			})
		},
		// 跳转专科系列课
		jumpjuniorCollege(item){
			this.$router.push({
				path: "/juniorCollege/" + item.specialty_id,
			})
		},
        // 跳转视频列表详情
        jumpVideoListInner(item){
            const that = this
            that.$router.push({
                path: '/videolistInner/' + item.class_id,
            })
        },
        // 跳转视频详情
        jumpVideoDetail(item){
            const that = this
			console.log(item)
			var data = {
                type: "getSeriesFirstVideoInfo",
				classId: item.class_id
			}
			that.get('/3/mobileHandler', data, 1).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					var data = {
						dataType: 0,
						No: result.video_no,
						name: result.video_name,
						classType: 1,
						classId: item.class_id
					}
					that.$router.push({
						path: '/videoDetail',
						query: {
							text: that.encrypt(JSON.stringify(data))
						}
					})
                }
			})
        },
		// 切换专科
		changeActiveSpecialtyId(item){
			const that = this
			that.activeSpecialtyId = item.specialty_id
			that.index = 0
			that.getSpecialtySeries()
		},
		// 切换最新最热
		changeorderByType(index){
			this.orderByType = index
			// 切换后获取课程列表
			this.getSpecialtySeries()
		},
        // 翻页
        changeBtn(e){
            const that = this
            that.index = e
            that.getSpecialtySeries()
        },
		// 获取专科列表
		getVideoSpecialtyList() {
			const that = this
			var data = {
                type: "getVideoSpecialtyList",
			}
			that.get('/webhttp/mobileHandler', data).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					that.SpecialtyDataList = result
                }
			})
		},
		// 获取专科下的系列课
		getSpecialtySeries() {
			const that = this
			var data = {
                type: "getSpecialtySeries",
                spectionId: that.activeSpecialtyId, // 专科ID
                classType: 0, // 0视频 1直播 2培训
                orderByType: that.orderByType, // 排序类型 0综合，1最热，2最新
                index: that.index,
                count: 12,
			}
			if(that.activeSpecialtyId == 0){
				data.spectionId = ""
			}
			that.get('/webhttp/mobileHandler', data, 1).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					that.total = res.data.count
					for (let i = 0; i < result.length; i++) {
						const element = result[i].teachers
						// 讲师人数超过三个显示等
						if(element && element.split(",").length > 3){
							result[i].teachers = element.split(",").slice(0,3).join(",")+"等"
						}
					}
					that.videoDataList = result
                }
			})
		},
		// 获取专科系统课
		getSpectialtyList() {
			const that = this
			var data = {
                type: "getSpectialtyList",
			}
			that.get('/webhttp/mobileHandler', data).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					that.SpectialtyDataList = result
                }
			})
		},
		// 获取分级学习
		getGradeStudy() {
			const that = this
			var data = {
                type: "getGradeStudy",
			}
			that.get('/3/gradeStudy', data).then(res => {
                if (res.data.code == "success") {
                    var result = res.data.result
					that.GradeStudyDataList = result
                }
			})
		},
    },
}
</script>

<style lang="scss" scoped>
.content {
	display: flex;
	justify-content: space-between;
	.leftBox {
		width: 750px;
		.SpecialtyListBox {
			padding-bottom: 10px;
			border-bottom: 1px solid #e1e1e1;
			.titles {
				font-size: 23px;
				color: #444;
				height: 46px;
			}
			.specialtyList {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.specialtyItem {
					width: 80px;
					text-align: center;
					margin: 5px 0;
					font-size: 16px;
					color: #333333;
					cursor: pointer;
					&:hover {
						color: #206DAF;
					}
				}
				.active {
					color: #206DAF;
				}
			}
		}

		.videoListBox {
			padding: 20px 0;
			.changeBtnBox {
				display: flex;
				align-items: center;
				margin-right: 10px;
				font-size: 16px;
				color: #333;
				padding-bottom: 20px;
				.changeBtnItem {
					margin-right: 20px;
					cursor: pointer;
				}
				.active {
					color: #206DAF;
				}
			}

			.videoList {
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.videoItem {
					display: flex;
					align-items: center;
					flex-direction: column;
					width: 228px;
					height: 240px;
					margin-right: 20px;
					margin-bottom: 15px;
					cursor: pointer;
					border-radius: 5px;
					box-shadow: 1px 5px 7px rgba(187, 187, 187, 0.65);
					&:hover {
						box-shadow: 2px 7px 11px rgb(217, 232, 247);
					}
					&:nth-child(3n){
						margin-right: 0;
					}
					.videoImg {
						width: 228px;
						height: 130px;
						box-sizing: border-box;
						border-radius: 5px;
					}
					.videoNmae {
						width: 100%;
						text-align: left;
						font-size: 17px;
						color: #444;
						padding: 10px 10px 0;
						box-sizing: border-box;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						-webkit-box-orient: vertical;
						box-sizing: border-box;
					}
					.videoLecturer, .videostate {
						width: 100%;
						font-size: 13px;
						color: #777;
						text-align: left;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1;
						-webkit-box-orient: vertical;
						padding: 2.5px 8px;
						box-sizing: border-box;
					}
				}
			}
		}
	}
	.rightBox {
		width: 400px;
		.GradeStudyListBox {
			background: linear-gradient(180deg, #e6efff, #fff);
			border-radius: 10px;
			border: 1px solid #ececec;
			margin-bottom: 20px;
			.titles {
				font-size: 24px;
				color: #444;
				height: 46px;
				padding: 20px;
				font-weight: 600;
			}
			.gradeStudyList {
				display: flex;
				align-items: center;
				justify-content: space-between;
				flex-wrap: wrap;
				padding: 0 20px;
				font-weight: 600;
				.gradeStudyItem {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 174px;
					height: 92px;
					margin-bottom: 15px;
					border-radius: 5px;
					color: #333;
					background-color: #fff;
					box-shadow: 0 0 10px 2px #f8f8f8;
					cursor: pointer;
					&:hover {
						color: #206DAF;
						box-shadow: 2px 7px 11px rgb(217, 232, 247);
					}
					.itemIcon {
						width: 40px;
						height: 40px;
						margin-right: 20px;
					}
					.itemIcon2 {
						width: 50px;
						height: 50px;
						margin-right: 15px;
					}
					.itemInfo {
						display: flex;
						flex-direction: column;
						.name {
							font-size: 16px;
							padding-bottom: 6px;
						}
						.number {
							font-size: 13px;
							font-weight: 500;
						}
					}
				}
			}
		}

		.GradeStudyListBox2 {
			background: linear-gradient(180deg, #f2f1ff, #fff);
		}
	}
}
</style>